import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import trash from '../../../../assets/img/svg/table/trash.svg';
import GeoFilters from './GeoFilters';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import OtherFilters from './OtherFilters';
import { t } from 'i18next';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { resetGlobalFilters, setGlobalFilter } from '../../../../store/slice/global-filters';
import { useAllFilters } from '../../../../hook/useAllFilters';
import { Visibility } from '../../../../enum/Visibility';
import { FilterType } from '../../../../enum/FilterType';
import { resetGeoFilters } from '../../../../store/slice/filter-slice';

interface FilterProps {
  showDropdown: boolean;
  setOpenFilterDropDown: Dispatch<SetStateAction<boolean>>;
}

const FiltersSetup: React.FC<FilterProps> = ({ showDropdown, setOpenFilterDropDown }) => {
  const dispatch = useAppDispatch();

  const filterType = useAppSelector((state) => state.globalFilters.filterType);

  const [openDropdown, setOpenDropdown] = useState<{
    type: string;
    index: number;
  } | null>(null);

  const [justClosed, setJustClosed] = useState<{
    type: string;
    index: number;
  } | null>(null);

  const { handleApplyAllFilters } = useAllFilters();

  const filters = useAppSelector((state) => state.globalFilters);
  const updateFilters = (newFilters: { [key: string]: string }) => {
    Object.entries(newFilters).forEach(([key, value]) => {
      dispatch(
        setGlobalFilter({
          key: key as any,
          value,
        }),
      );
    });
  };

  function handleResetFilters() {
    dispatch(resetGlobalFilters());
    dispatch(resetGeoFilters())
  }

  const toggleDropdown = (type: string, index: number) => {
    if (openDropdown?.type === type && openDropdown?.index === index) {
      setJustClosed({ type, index });
      setOpenDropdown(null);
    } else {
      setJustClosed(null);
      setOpenDropdown({ type, index });
    }
  };

  const isOpen = (type: string, index: number) => openDropdown?.type === type && openDropdown?.index === index;

  useEffect(() => {
    if (!showDropdown) {
      setOpenDropdown(null);
      setJustClosed(null);
    }
  }, [showDropdown]);

  return (
    <div
      className={`filter_setup ${showDropdown ? Visibility.VISIBLE : Visibility.HIDDEN} ${
        showDropdown && openDropdown ? 'expanded' : 'not_expanded'
      } ${filterType === FilterType.CASH_REGISTER_FILTERS ? 'cash_register_filter_setup' : ''}`}
    >
      {filterType === FilterType.NORMAL ? (
        <>
          <div className="filter_header">
            <span className="title">{t('statisticPage.header.filter.filterSetup')}</span>
            <div className="reset_all" onClick={() => handleResetFilters()}>
              <img src={trash} alt="Reset all" />
              <span>{t('statisticPage.header.filter.resetAll')}</span>
            </div>
          </div>
          <hr />
          <div className="filter_controls">
            <GeoFilters
              toggleDropdown={toggleDropdown}
              isOpen={isOpen}
              filters={filters}
              setFilters={updateFilters}
              justClosed={justClosed}
            />
            <OtherFilters
              filters={filters}
              setFilters={updateFilters}
              justClosed={justClosed}
              toggleDropdown={toggleDropdown}
              isOpen={isOpen}
            />

            <button
              className="apply_filters"
              onClick={() => {
                handleApplyAllFilters();
                setOpenFilterDropDown((prevState) => !prevState);
              }}
            >
              {t('statisticPage.header.filter.applyFilters')}
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="filter_header">
            <span className="title cash_register_title">{t('cashRegister.filters.header.selectAGroup')}</span>
            <div className="reset_all" onClick={() => handleResetFilters()}>
              <img src={trash} alt="Reset all" />
              <span>{t('statisticPage.header.filter.resetAll')}</span>
            </div>
          </div>
          <div className="filter_controls">
            <GeoFilters
              toggleDropdown={toggleDropdown}
              isOpen={isOpen}
              filters={filters}
              setFilters={updateFilters}
              justClosed={justClosed}
            />
            <button
              className="apply_filters"
              onClick={() => {
                handleApplyAllFilters();
                setOpenFilterDropDown((prevState) => !prevState);
              }}
            >
              {t('statisticPage.header.filter.applyFilters')}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default FiltersSetup;
